import LoadingOrErrorPanel from 'components/LoadingOrErrorPanel';
import { useAuth } from 'context/AuthContext';
import { PowerBIEmbed } from 'powerbi-client-react';
import React, { useEffect, useState, useRef } from 'react';
import PowerBiService from 'services/PowerBiService';
import * as pbi from 'powerbi-client';
import MasterPage from '../../EstruturaAntiga/masterpages/authenticated';
import ContentBox from 'components/ContentBox';
import { Button, Select } from 'antd';
import { FullscreenExitOutlined, FullscreenOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { BarraBotoes } from './styles';

const RelatorioPowerBi = ({history}) => {
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(null);
    const [biToken, setBiToken] = useState({});
    const [navegacao, setNavegacao] = useState({});
    const [report, setReport] = useState(null);
    const [pages, setPages] = useState([]);
    const [activePage, setActivePage] = useState(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const {ObterParametrosRelatorio, ObterNavegacaoPeloCaminho} = useAuth();
    const fullscreenContainerRef = useRef(null);

    useEffect(()=> {
        setNavegacao(ObterNavegacaoPeloCaminho(history.location.pathname))
        ObterAccessToken();
    },[]);

    useEffect(() => {
        const handleFullScreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullScreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullScreenChange);
        };
    }, []);

    useEffect(() => {
        if (report) {
            const handleReportLoad = async () => {
                try {
                    const allPages = await report.getPages();
                    const visiblePages = allPages.filter(x=>x.visibility == 0);
                    setPages(visiblePages);
                    const activePage = await report.getActivePage();
                    setActivePage(activePage);
                } catch (error) {
                    setPages([]);
                }
            };

            const handlePageChange = (event) => {
                setActivePage(event.detail.newPage);
            };
    
            report.on('loaded', handleReportLoad);
            report.on('pageChanged', handlePageChange);

            return () => {
                report.off('loaded', handleReportLoad);
                report.off('pageChanged', handlePageChange);
            };
        }
    }, [report]);
    
    const ObterAccessToken = async () =>{
        var parametros = ObterParametrosRelatorio(history.location.pathname);
        await PowerBiService.ObterTokenRls(parametros).then(response=>{
            setBiToken(response)
            setLoading(false)
        })
        .catch(error=>{
            setLoading(false)
            setHasError(true)
        });
    };

    const handlePreviousPage = async () => {
        const pageIndex = pages.findIndex(p => p.name === activePage.name);
        if (pageIndex > 0) {
            await report.setPage(pages[pageIndex - 1].name);
        }
    };
    
    const handleNextPage = async () => {
        const pageIndex = pages.findIndex(p => p.name === activePage.name);
        if (pageIndex < pages.length - 1) {
            await report.setPage(pages[pageIndex + 1].name);
        }
    };
    
    const handleSelectPage = async (pageName) => {
        await report.setPage(pageName);
    };

    const toggleFullScreen = () => {
        if (isFullscreen) {
            document.exitFullscreen();
        } else {
            fullscreenContainerRef.current?.requestFullscreen();
        }
    };

    return(
        <MasterPage useFullWidth>
            <LoadingOrErrorPanel loading={loading} hasError={hasError} style={{"height": "100%"}}>
                <ContentBox className="bi-content">
                    <div ref={fullscreenContainerRef} style={{ display: 'flex', flexDirection: 'column',height: "100%" }}>
                        <PowerBIEmbed 
                            cssClassName='bi-report'
                            embedConfig={{
                                type: 'report',
                                id: biToken?.reportData?.id,
                                embedUrl: biToken?.embedURL,
                                accessToken: biToken?.token,
                                tokenType: pbi.models.TokenType.Embed,
                                settings: {
                                    panes: { pageNavigation: { visible: false}, filters: {visible: false}},
                                    bars: { statusBar: { visible: true}},
                                    localeSettings: {language: "pt-br"}
                                },
                            }}
                            getEmbeddedComponent={(embeddedReport) => {
                                setReport(embeddedReport);
                            }}
                        />
                        {!loading && !hasError && (
                            <BarraBotoes>
                                <span>{biToken?.reportData?.name || 'Relatório'}</span>
                                <div className="buttons-container">
                                    {pages.length > 1 && activePage && navegacao.permitirTrocaAbaRelatorio &&(
                                        <>
                                            <Button
                                                icon={<LeftOutlined />}
                                                onClick={handlePreviousPage}
                                                disabled={pages.findIndex(p => p.name === activePage.name) === 0}
                                                style={{ background: 'transparent', color: 'white', border: 'none' }}
                                            />
                                            <Select
                                                rootClassName='relatorioPowerBiPagesSelect'
                                                value={activePage.name}
                                                onChange={handleSelectPage}
                                                style={{ width: 250, color: 'white' }}
                                                dropdownStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.9)', color: 'white' }}
                                                variant={'borderless'}
                                            >
                                                {pages.map(page => (
                                                    <Select.Option key={page.name} value={page.name} style={{ color: 'white' }}>
                                                        {page.displayName}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                            <Button
                                                icon={<RightOutlined />}
                                                onClick={handleNextPage}
                                                disabled={pages.findIndex(p => p.name === activePage.name) === pages.length - 1}
                                                style={{ background: 'transparent', color: 'white', border: 'none' }}
                                            />
                                        </>
                                    )}
                                </div>
                                <Button
                                    className='toggle-fullscreen'
                                    onClick={toggleFullScreen}
                                    alt="Toggle Fullscreen"
                                    icon={isFullscreen ? <FullscreenExitOutlined /> :  <FullscreenOutlined/> }
                                />
                            </BarraBotoes>
                        )}
                    </div>
                </ContentBox>
            </LoadingOrErrorPanel>
        </MasterPage>
    )
}

export default RelatorioPowerBi